export enum Permission {
  AggregateStorePerformance = 'store_performance.view',
}
